import { createContext, useContext } from 'react';

export const EsriMapsContext = createContext({});
export const EsriMapsConsumer = EsriMapsContext.Consumer;

export const useEsriMapsContext = () => useContext(EsriMapsContext);
